import React from "react";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, DescriptionCardHeading, FormLayout, FormLayoutSectionFormatProps} from "peggirkit";
import {slimCardFormLayoutProps} from "@widgets/layout/formLayout/FormLayout";
import FormLayoutSection from "peggirkit/dist/components/Form/Layout/LayoutSection/FormLayoutSection";
import {FormattedMessage, useIntl} from "react-intl";
import LoyaltyRewardDetailsForm from "@widgets/loyaltyRewards/editor/card/LoyaltyRewardDetailsForm";
import {SetLoyaltyRewardProps} from "@pages/authenticated/admin/loyaltyRewards/LoyaltyReward";



type Props = SetLoyaltyRewardProps & {
    initialLoading: boolean,
    restaurantId: number,
};


const EditLoyaltyRewardCard = ({loyaltyReward, setLoyaltyReward, initialLoading, restaurantId}: Props) => {
    const intl = useIntl();

    return (
        <Card
            header={
                <CardHeader>
                    <DescriptionCardHeading
                        title={intl.formatMessage({id: "details"})}
                        description={intl.formatMessage({id: "viewOrEditLoyaltyReward"})}
                    />
                </CardHeader>
            }
        >
            <FormLayout {...slimCardFormLayoutProps}>
                {(layoutProps: FormLayoutSectionFormatProps) => (
                    <>
                        <FormLayoutSection
                            {...layoutProps}
                            title={<FormattedMessage id={"general"}/>}
                            description={<FormattedMessage id={"loyaltyRewardEditDescription"}/>}
                            noBorder
                            noPadding
                        >
                            <LoyaltyRewardDetailsForm
                                setLoyaltyReward={setLoyaltyReward}
                                loyaltyReward={loyaltyReward}
                                initialLoading={initialLoading}
                                restaurantId={restaurantId}
                            />
                        </FormLayoutSection>
                    </>
                )}
            </FormLayout>
        </Card>
    );
};

export default EditLoyaltyRewardCard;